import {Component, ContentChildren, OnInit, QueryList} from '@angular/core';
import {AccordionItemComponent} from './item/accordion-item.component';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit {
  @ContentChildren(AccordionItemComponent, {'read' : AccordionItemComponent}) components: QueryList<AccordionItemComponent>;

  constructor() { }

  ngOnInit() {
  }
}
